import React from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';

import { useGlobalState, useSessionState } from '../global-state';
import { useFormatPriceFn } from '../price/price';

const getTranslationKeyByDeliveryType = (deliveryType: string) => {
  switch (deliveryType) {
    case 'mailbox':
      return 'widget.FSI_TEXT_TYPE_MAILBOX';
    case 'delivery':
      return 'widget.FSI_TEXT_TYPE_DELIVERY';
    case 'instore':
      return 'widget.FSI_TEXT_TYPE_INSTORE';
    case 'pickup':
      return 'widget.FSI_TEXT_TYPE_PICKUP';
    default:
      return 'widget.FSI_TEXT_TYPE_DELIVERY';
  }
};

interface FreeShippingTextProps {
  value: number;
}

export const FreeShippingText: React.FC<FreeShippingTextProps> = ({ value }) => {
  const { tICU } = useTranslations();
  const formatFn = useFormatPriceFn();
  const globalState = useGlobalState();
  const session = useSessionState();

  const { next_level_price } = globalState;

  const price = formatFn(value);

  const text = session.flags.enable_free_shipping_indicator_category_name_message
    ? tICU('widget.FSI_TEXT_CATEGORY_NAME', {
        category_name: next_level_price!.category!.category_name ?? '',
        price,
      })
    : tICU(getTranslationKeyByDeliveryType(next_level_price!.category!.delivery_type!), {
        carrier_name: next_level_price!.shipping_option!.carrier_name ?? '',
        price,
      });

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  );
};
